(function () {
  'use strict';

  if (customElements.get('parallax-image-section')) return;

  var MAX_SHIFT_RATIO = 0.15; // image can move up to 15% of the section's own height
  var STRENGTH = 0.25; // how much of the scroll distance turns into movement
  var reduceMotionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  class ParallaxImageSection extends HTMLElement {
    constructor() {
      super();
      this._onScroll = this._onScroll.bind(this);
      this._update = this._update.bind(this);
      this._observer = null;
      this._ticking = false;
      this._isVisible = false;
    }

    connectedCallback() {
      this._image = this.querySelector('[data-parallax-image]');
      this._isPreview = this.getAttribute('data-is-preview-mode') === 'true';

      if (!this._image || this._isPreview) return;

      this._image.style.transform = 'translate3d(0, 0, 0)';

      if (reduceMotionQuery.matches) return;

      this._observer = new IntersectionObserver(
        (entries) => {
          var entry = entries[0];
          this._isVisible = entry.isIntersecting;
          if (this._isVisible) this._requestTick();
        },
        { rootMargin: '200px 0px 200px 0px' }
      );
      this._observer.observe(this);

      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll);
      this._requestTick();

      var self = this;
      reduceMotionQuery.addEventListener('change', function (e) {
        if (e.matches) {
          window.removeEventListener('scroll', self._onScroll);
          self._image.style.transform = 'translate3d(0, 0, 0)';
        } else {
          window.addEventListener('scroll', self._onScroll, { passive: true });
          self._requestTick();
        }
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
      if (this._observer) this._observer.disconnect();
    }

    _onScroll() {
      if (!this._isVisible) return;
      this._requestTick();
    }

    _requestTick() {
      if (this._ticking) return;
      this._ticking = true;
      window.requestAnimationFrame(this._update);
    }

    _update() {
      this._ticking = false;

      var rect = this.getBoundingClientRect();
      var viewportCenter = window.innerHeight / 2;
      var sectionCenter = rect.top + rect.height / 2;
      var distance = viewportCenter - sectionCenter;

      var maxShift = rect.height * MAX_SHIFT_RATIO;
      var offset = distance * STRENGTH;

      if (offset > maxShift) offset = maxShift;
      if (offset < -maxShift) offset = -maxShift;

      this._image.style.transform = 'translate3d(0, ' + offset.toFixed(1) + 'px, 0)';
    }
  }

  customElements.define('parallax-image-section', ParallaxImageSection);
})();